'use client';

import clsx from 'clsx';

import { FC } from 'react';

import {
  FasChevronDown,
  FasChevronUp,
} from '@virginmediao2/momentum-icons/icons/fas';

import { Icon } from '@/components/momentum/components/icon';
import { L2Category } from '@/components/storyblok/bloks/dynamo-megamenu/dropdown/l2-category';
import { DynamoNavigation } from '@/components/storyblok/types/dynamo-navigation';

import styles from './side-navigation-item.module.scss';

export interface SideNavigationItemProps {
  blok: DynamoNavigation;
}

export const SideNavigationItem: FC<SideNavigationItemProps> = ({ blok }) => {
  return (
    <>
      <button
        data-sidenav-trigger-item
        className={clsx(
          styles['mega-menu-side-navigation-item__trigger'],
          'toggle-icon-button'
        )}
      >
        <div
          className={clsx(
            styles['mega-menu-side-navigation-item__trigger-icon'],
            'opened-icon'
          )}
        >
          <Icon icon={FasChevronUp} />
        </div>
        <div
          className={clsx(
            styles['mega-menu-side-navigation-item__trigger-icon'],
            'closed-icon'
          )}
        >
          <Icon icon={FasChevronDown} />
        </div>
        {blok?.title}
      </button>
      <div
        className={clsx(
          styles['mega-menu-side-navigation-item__items'],
          'toggle-show'
        )}
        data-sidenav-content-item
      >
        <L2Category category={blok} />
      </div>
    </>
  );
};
